export default ({ isTalkMeEnabled }: { isTalkMeEnabled: boolean }) => ({
  script: [{
    innerHTML: `
      (function(w,d,s,l,i) {
        w[l]=w[l]||[];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event:'gtm.js'
        });
      var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';

      j.async=true;
      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);

      })(window,document,'script','dataLayer','GTM-WM43C7');
    `,
  },
  {
    innerHTML: `
      (function(win, doc, txt) {
        function c(d, w, m, i) {

          if(!${isTalkMeEnabled}) {
            return;
          }

          w.supportAPIMethod = m;
          var s = d.createElement('script');
          s.id = 'supportScript';
          var id = '44e7b08b9c3a49cf13cfe5b308aa0959';
          s.src = (!i ? 'https://lcab.talk-me.ru/support/support.js' : 'https://static.site-chat.me/support/support.int.js') + '?h=' + id;
          s.onerror = i ? undefined : function() {
              c(d, w, m, true);
          };
          w[m] = w[m] || function() {
              (w[m].q = w[m].q || []).push(arguments);
          };
          (d.head || d.body).appendChild(s);
        }

        window.addEventListener('load', function(){ c(doc, win, txt); }, true);
      })(window, document, 'TalkMe');
    `,
    async: true,
  }],
  noscript: [{
    innerHTML: `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WM43C7" height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `,
    pbody: true, // prepend body (вставить скрипт сразу после тега body)
  }],
  __dangerouslyDisableSanitizers: ['script'],
});
